import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { isAdminSelector, factoriesSelector, architectureSelector } from '../selectors';
import { createArchitecture, deleteArchitecture, fetchArchitecture } from '../actions/entry';
import Architecture from '../components/Architecture';

const mapStateToProps = (state) => {
  const isAdmin = isAdminSelector(state);
  const factories = factoriesSelector(state);
  const architectures = architectureSelector(state);

  return {
    isAdmin,
    architectures,
    factories,
  };
};

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      onArchitectureCreate: (factoryId, data) => createArchitecture(factoryId, data),
      onFetchArchitecture: (data) => fetchArchitecture(data.factoryId),
      onArchitectureDelete: deleteArchitecture,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Architecture);
